var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/gps-logo.svg")}}),_c('span',{staticClass:"ml-2 text-22-b"},[_vm._v("Где нас найти?")])]),_c('div',{attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }